class AppLocalStorageCl {
    public setLSToken(token?: string) {
      localStorage.setItem('accessToken', JSON.stringify(token));
    }
  
    public getLSToken() {
      const token = localStorage.getItem('accessToken');
      return token ? JSON.parse(token) : 'token empty';
    }
  }
  
  export const AppLocalStorage = new AppLocalStorageCl();